import { render, staticRenderFns } from "./EkrmRevenueCard.vue?vue&type=template&id=2414cb3a&scoped=true&"
import script from "./EkrmRevenueCard.vue?vue&type=script&lang=js&"
export * from "./EkrmRevenueCard.vue?vue&type=script&lang=js&"
import style0 from "./EkrmRevenueCard.vue?vue&type=style&index=0&id=2414cb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414cb3a",
  null
  
)

export default component.exports